import { useEffect, useState } from "react";

export const useScrollPartition = (from: number, to?: number) => {
    const [partition, setPartition] = useState(0);
    useEffect(() => {
        if (!window) return;
        const scrollHandler = () => {
            if (window.scrollY <= from) {
                setPartition(0);
            } else if ((to && window.scrollY >= to) || !to) {
                setPartition(1);
            } else {
                setPartition((window.scrollY - from) / (to - from));
            }
        };
        window.addEventListener("scroll", scrollHandler);
        return () => {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    return partition;
};
